import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { DefaultPlanForm } from "../DefaultPlanForm";
import { CreateDefaultPlanModalProps } from "./types";
import { useCreateDefaultPlanModal } from "./controller";

export const CreateDefaultPlanModal = React.memo(
  ({ modalRef, onComplete }: CreateDefaultPlanModalProps) => {
    const translate = useTranslate();

    const { methods, mutateAsync, isPending } =
      useCreateDefaultPlanModal(modalRef, onComplete);

    return (
      <Modal
        ref={modalRef}
        title={translate("default_plan_admin.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <DefaultPlanForm />
      </Modal>
    );
  }
);
